
<template>
	<main class="d-flex" style="justify-content: center; align-items: center; min-height: 100vh;">

		<b-card class="w-25 bg-dark">
			<form @submit.prevent="fazerLogin()" class="d-flex flex-column gap-md mx-auto my-auto mt-5 w-100">
				<img src="../assets/logo.png" class="w-100 mx-auto my-5">
				<div class="d-flex flex-column">
					<label for="floatingInput">Email:</label>
					<input required type="email" v-model="login.email" class="form-control" id="floatingInput"
						placeholder="email@example.com">
				</div>
				<div class="d-flex flex-column">
					<label>
						Senha:</label>
				<b-input-group>
                    <b-form-input v-model="login.senha" :type="typeInputSenha" placeholder="Digite sua senha..."></b-form-input>
                    <b-input-group-append>
                        <b-button variant="secondary" @click="handleMostrarSenha()">
                            <font-awesome-icon :icon="iconesMostrarSenha" />
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
				</div>
				<div class="d-flex flex-column gap-sm">
					<button :disabled="carregando" class="w-100 btn btn-lg btn-success mt-3" type="submit">
					<span v-if="!carregando">Entrar</span>
					<b-spinner variant="white" v-if="carregando"></b-spinner>
				</button>
				<div class="d-flex w-100 justify-content-center">
					<span class="link" @click="$bvModal.show('modal-esqueci-minha-senha')">Esqueci Minha Senha</span>
					<ModalEsqueciMinhaSenha/>
				</div>
				</div>
			</form>
		</b-card>

	</main>
</template>

<script>
import Login from "../model/Login.js";
import AuthService from "../service/AuthService.js";
import  setaAxios  from "../service/Axios.js";
import ModalEsqueciMinhaSenha from "../components/Login/ModalEsqueciMinhaSenha.vue";

export default{
	name: "Login",
	components: {
		ModalEsqueciMinhaSenha,
	},
	data() {
		return {
			login: new Login(),
			error: "erro",
			carregando: false,
			iconesMostrarSenha: "fa-solid fa-eye",
			typeInputSenha: "password",
		};
	},
	created() {
		localStorage.clear();
		setaAxios();
	},
	methods: {
		handleMostrarSenha() {
			if (this.typeInputSenha == "password") {
				this.typeInputSenha = "text";
				this.iconesMostrarSenha = "fa-solid fa-eye-slash";
			} else {
				this.typeInputSenha = "password";
				this.iconesMostrarSenha = "fa-solid fa-eye";
			}
		},
		fazerLogin() {
			this.carregando = true;
			AuthService.login(this.login)
				.then((res) => {
					localStorage.setItem("usuario", JSON.stringify(res.data));
					this.$router.push("/");
					window.location.reload();
				}).catch((err) => {
					this.error = err.response.data;
					this.mensagem(this.error, "Aviso", "danger");
				}).finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>

<style scoped>

.link{
	font-size: 13px;
	color:  white;
	cursor: pointer;
	transition: all 0.1s ease-in;
}
.link:hover{
	color: blue;
}
label{
	color: white !important;
}
@media screen and (max-width: 968px) {
    .card{
        width: 80% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue